import API from './index';
import '../helpers';

function login(params) {
	const options = {
		method: 'POST'
	};
	const data = {
		caseNumber: params.data.caseNumber,
		password: params.data.password
	};
	return API.post('/login', data, options)
		.then((result) => {
			return result;
		})
		.catch((error) => {
			throw error.response;
		});
}

function forgetPassword(params) {
	const options = {
		method: 'POST',
	};
	const data = {
		caseNumber: params.data.caseNumber
	};
	return API.post('/password/create', data, options)
		.then((result) => {
			return result;
		})
		.catch((error) => {
			throw error.response;
		});
}

function updatePassword(params) {
	const options = {
		method: 'POST',
	};
	const data = {
		email: params.data.email,
		password: params.data.password,
		confirmed: params.data.confirmed,
		token: params.data.token
	};
	return API.post('/password/reset', data, options)
		.then((result) => {
			return result;
		})
		.catch((error) => {
			throw error.response;
		});
}


function register(params) {
	const options = {
		method: 'POST'
	};
	const data = params.data.accountFields;
	return API.post('/register', data, options)
		.then((result) => {
			return result;
		})
		.catch((error) => {
			throw error.response;
		});
}

function getActions (params) {
	// console.log(params);
	const options = {
		method: 'GET',
		headers: {
			'auth-token': `${params.authToken}`
		}
	};
	
	return API.get('/dashboard', options)
		.then((result) => {
			return result;
		})
		.catch((error) => {
			throw error.response;
		});
}


export const authenticationService = {
	login,
	register,
	forgetPassword,
	updatePassword,
	getActions
};
